import { IconDefinition } from '@ant-design/icons-angular';
import {
  AppstoreOutline,
  ArrowLeftOutline,
  BorderOutline,
  CaretDownOutline,
  CaretRightOutline,
  CheckCircleOutline,
  CheckCircleTwoTone,
  CheckOutline,
  CheckSquareOutline,
  ClearOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CloseCircleTwoTone,
  CloseOutline,
  CloseSquareOutline,
  CloudSyncOutline,
  CoffeeOutline,
  ControlOutline,
  CopyOutline,
  CrownOutline,
  DashboardOutline,
  DashOutline,
  DeleteOutline,
  DeploymentUnitOutline,
  DesktopOutline,
  DollarCircleOutline,
  DotChartOutline,
  DoubleRightOutline,
  DownCircleOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  EllipsisOutline,
  EnvironmentOutline,
  ExpandAltOutline,
  ExpandOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FieldTimeOutline,
  FileDoneOutline,
  FileExcelOutline,
  FileImageOutline,
  FileOutline,
  FilterOutline,
  FormOutline,
  GatewayOutline,
  HomeOutline,
  HolderOutline,
  InboxOutline,
  InfoCircleOutline,
  IssuesCloseOutline,
  LeftOutline,
  LineChartOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  LoginOutline,
  MailOutline,
  MinusCircleOutline,
  MobileOutline,
  MoreOutline,
  PercentageOutline,
  PhoneOutline,
  PictureOutline,
  PlusCircleOutline,
  PlusOutline,
  PrinterOutline,
  PushpinOutline,
  QuestionCircleOutline,
  QuestionOutline,
  ReconciliationOutline,
  RedoOutline,
  ReloadOutline,
  RetweetOutline,
  RightCircleOutline,
  RightOutline,
  RollbackOutline,
  SaveOutline,
  ScheduleOutline,
  SearchOutline,
  SelectOutline,
  SendOutline,
  SettingOutline,
  SketchOutline,
  StarOutline,
  StopOutline,
  SwapOutline,
  SyncOutline,
  TableOutline,
  UndoOutline,
  UpOutline,
  UploadOutline,
  UserOutline,
  WarningOutline,
  WarningTwoTone,
  ZoomInOutline,
  ZoomOutOutline,
} from '@ant-design/icons-angular/icons';

export const APP_ICONS: IconDefinition[] = [
  AppstoreOutline,
  ArrowLeftOutline,
  BorderOutline,
  CaretDownOutline,
  CaretRightOutline,
  CheckCircleOutline,
  CheckCircleTwoTone,
  CheckOutline,
  CheckSquareOutline,
  ClearOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CloseCircleTwoTone,
  CloseOutline,
  CloseSquareOutline,
  CloudSyncOutline,
  CoffeeOutline,
  ControlOutline,
  CopyOutline,
  CrownOutline,
  DashboardOutline,
  DashOutline,
  DeleteOutline,
  DeploymentUnitOutline,
  DesktopOutline,
  DollarCircleOutline,
  DotChartOutline,
  DoubleRightOutline,
  DownCircleOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  EllipsisOutline,
  EnvironmentOutline,
  ExpandAltOutline,
  ExpandOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FieldTimeOutline,
  FileDoneOutline,
  FileExcelOutline,
  FileImageOutline,
  FileOutline,
  FilterOutline,
  FormOutline,
  GatewayOutline,
  HomeOutline,
  HolderOutline,
  InboxOutline,
  InfoCircleOutline,
  IssuesCloseOutline,
  LeftOutline,
  LineChartOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  LoginOutline,
  MailOutline,
  MinusCircleOutline,
  MobileOutline,
  MoreOutline,
  PercentageOutline,
  PhoneOutline,
  PictureOutline,
  PlusCircleOutline,
  PlusOutline,
  PrinterOutline,
  PushpinOutline,
  QuestionCircleOutline,
  QuestionOutline,
  ReconciliationOutline,
  RedoOutline,
  ReloadOutline,
  RetweetOutline,
  RightCircleOutline,
  RightOutline,
  RollbackOutline,
  SaveOutline,
  ScheduleOutline,
  SearchOutline,
  SelectOutline,
  SendOutline,
  SettingOutline,
  SketchOutline,
  StarOutline,
  StopOutline,
  SwapOutline,
  SyncOutline,
  TableOutline,
  UndoOutline,
  UpOutline,
  UploadOutline,
  UserOutline,
  WarningOutline,
  WarningTwoTone,
  ZoomInOutline,
  ZoomOutOutline,
];
